/**
 * Format a date string or Date object to readable format
 * Input: "2026-03-02T04:22:41.000Z" or Date object
 * Output: "2026-03-02 04:22:41" (YYYY-MM-DD HH:mm:ss)
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return "-";
  
  try {
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    if (isNaN(date.getTime())) return "-";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (e) {
    return "-";
  }
};

/**
 * Format a date string to DD-MMM-YYYY HH:mm format
 * Input: "2026-03-02T04:22:41.000Z"
 * Output: "02-Mar-2026 04:22"
 */
export const formatDateCompact = (dateInput) => {
  if (!dateInput) return "-";
  
  try {
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    if (isNaN(date.getTime())) return "-";

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  } catch (e) {
    return "-";
  }
};
